const googleMapInit = () => {
    const maps = Array.from(document.querySelectorAll('.bn-google-map'));

    function initMap(el) {
        const styles = [
            {
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 65
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": "50"
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "30"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "40"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#ffff00"
                    },
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -97
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -100
                    }
                ]
            }
        ];
    
        const markers = el.querySelectorAll('.marker');
    
        const mapArgs = {
            zoom: el.dataset.zoom || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: styles,
            disableDefaultUI: true,
        };
        const map = new google.maps.Map(el, mapArgs);
    
        map.markers = [];
        markers.forEach(function (marker) {
            initMarker(marker, map);
        });
    
        centerMap(map);
    
        return map;
    }
    
    /**
     * initMarker
     *
     * Creates a marker for the given element and map.
     *
     * @param   HTMLElement marker The marker element.
     * @param   object map The map instance.
     * @return  object The marker instance.
     */
    function initMarker(marker, map) {
        // Get position from marker.
        const lat = parseFloat(marker.dataset.lat.replace(',', '.'));
        const lng = parseFloat(marker.dataset.lng.replace(',', '.'));
    
        const latLng = { lat: lat, lng: lng };
    
        const markerSetting = {
            position: latLng,
            map: map,
        };
    
        if (marker.dataset.icon) {
            markerSetting.icon = {
                url: marker.dataset.icon,
                scaledSize: new google.maps.Size(43, 64),
                anchor: new google.maps.Point(21.5, 64),
            };
        }
    
        const googleMarker = new google.maps.Marker(markerSetting);
    
        map.markers.push(googleMarker);

        if (marker.dataset.label) {
            const labelOverlay = new google.maps.OverlayView();

            labelOverlay.onAdd = function () {
                this.element = document.createElement('div');
                this.element.className = 'bn-google-map__marker-label';
                this.element.textContent = marker.dataset.label;
                this.getPanes().overlayMouseTarget.appendChild(this.element);
            };

            labelOverlay.draw = function () {
                const position = this.getProjection().fromLatLngToDivPixel(googleMarker.getPosition());

                if (position && this.element) {
                    this.element.style.left = `${position.x}px`;
                    this.element.style.top = `${position.y}px`;
                }
            };

            labelOverlay.onRemove = function () {
                this.element?.remove();
            };

            labelOverlay.setMap(map);
        }
    
        // If marker contains HTML, add it to an infoWindow.
        if (marker.innerHTML.trim()) {
            // Create info window.
            const infowindow = new google.maps.InfoWindow({
                content: marker.innerHTML,
            });
    
            // Show info window when marker is clicked.
            googleMarker.addListener('click', function () {
                infowindow.open(map, googleMarker);
            });
        }
    }
    
    /**
     * Centers the map showing all markers in view.
     *
     * @param   object map The map instance.
     * @return  void
     */
    function centerMap(map) {
        const bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng(),
            });
        });
    
        if (map.markers.length === 1) {
            map.setCenter(bounds.getCenter());
        } else {
            map.fitBounds(bounds);
        }
    }

    if (maps) {
        maps.forEach(map => {
            initMap(map);
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        googleMapInit();
});

